module.exports = __webpack_public_path__ + "static/img/logo29.6ba3b6a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo29.png
// module id = wbl0
// module chunks = 1